import { ChangeDetectionStrategy, Component, HostBinding, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
	MatLegacySnackBarRef as MatSnackBarRef,
} from "@angular/material/legacy-snack-bar";
import { SnackBarCacheService } from "@obg/ngx.core";
import { fromMillisecondsToSeconds } from "@obg/ngx.global";
import { Observable, timer } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { SnackBarComponentBase, SnackBarOptions } from "./snackbar.model";

@Component({
	selector: "obg-m-snackbar",
	templateUrl: "./snackbar.component.html",
	styleUrls: ["./snackbar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SnackBarComponent implements SnackBarComponentBase, OnInit {
	@HostBinding("class.obg-m-snackbar") cssHostClass = true;
	dismissibleCountDown$: Observable<number> | undefined;
	dismissibleCountDownTranslationKey = "";
	dismissibleMessageTranslationKey = "";

	constructor(
		private cacheService: SnackBarCacheService,
		@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarOptions,
		public snackBar: MatSnackBarRef<any>
	) {}

	ngOnInit() {
		if (!this.data.dismissibleDuration) {
			return;
		}

		this.dismissibleCountDownTranslationKey = `${this.data.dismissibleDurationTranslationPrefix}.countdown`;
		this.dismissibleMessageTranslationKey = `${this.data.dismissibleDurationTranslationPrefix}.dismiss`;
		const timeOut$ = timer(this.data.dismissibleDuration + 1000);

		this.dismissibleCountDown$ = timer(0, 1000).pipe(
			map((time) => fromMillisecondsToSeconds(this.data.dismissibleDuration!) - time),
			takeUntil(timeOut$)
		);
	}

	doNotShowAgain() {
		if (this.data.id) {
			this.cacheService.setSnackbarDoNotShowAgain(this.data.id);
			this.snackBar.dismiss();
		}
	}

	onDismiss() {
		this.snackBar.dismiss();
	}

	onDismissWithAction() {
		this.snackBar.dismissWithAction();
	}
}
